import React, { useState, useEffect } from "react";
import { Modal, Button, Form, DropdownButton, Dropdown } from "react-bootstrap";
import axios from "axios";
import {
  API_URL,
  numberOfQuestionsArray,
  questionTimerMapping,
} from "../../../constants/Globals";
import { getSequenceAdvertisingType } from "../../../services/CollectionsSvc";

const ConfigureQuizModal = ({
  show,
  onClose,
  onBack,
  onSave,
  selNetworkId,
}) => {
  const [quizName, setQuizName] = useState("");
  const [quizCategory, setQuizCategory] = useState([]);
  const [questionTimer, setQuestionTimer] = useState("Off");
  const [questionOrder, setQuestionOrder] = useState("In Order");
  const [showCorrectAnswers, setShowCorrectAnswers] = useState("Immediately");
  const [advertising, setAdvertising] = useState(null);
  const [numberOfQuestions, setNumberOfQuestions] = useState(1);
  const [categories, setCategories] = useState([]);
  const [questionTimerOptions, setQuestionTimerOptions] = useState([]);
  const [questionOrderOptions, setQuestionOrderOptions] = useState([]);
  const [showCorrectAnswersOptions, setShowCorrectAnswersOptions] = useState(
    []
  );
  const [advertisingOptions, setAdvertisingOptions] = useState([]);

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        setQuestionTimerOptions([
          "Off",
          "5 seconds",
          "10 seconds",
          "15 seconds",
          "20 seconds",
          "30 seconds",
        ]);

        setQuestionOrderOptions(["In Order", "Random"]);

        setShowCorrectAnswersOptions(["Immediately", "End of Quiz"]);

        const advertisingResponse = await getSequenceAdvertisingType();
        setAdvertisingOptions(advertisingResponse.data.data || []);

        if (selNetworkId) {
          const categoriesResponse = await axios.get(
            `${API_URL}/categories?clientId=${selNetworkId}`
          );
          setCategories(categoriesResponse.data.data || []);
        }
      } catch (error) {
        console.error("Failed to fetch dropdown options:", error);
      }
    };

    fetchOptions();
  }, [selNetworkId]);

  const handleSave = () => {
    if (!quizName.trim()) {
      alert("Quiz Name is required.");
      return;
    }

    const selectedCategories = categories
      .filter((category) => quizCategory.includes(category.text))
      .map((category) => ({ category }));

    const quizConfig = {
      quizName,
      quizCategory: selectedCategories,
      questionTimer: questionTimerMapping[questionTimer] || 0,
      questionOrder,
      showCorrectAnswers,
      advertising,
    };

    if (selectedCategories?.length > 0) {
      quizConfig.numberOfQuestions = parseInt(numberOfQuestions);
    }

    onSave(quizConfig);
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      dialogClassName="custom-modal-width"
      size="lg"
      keyboard={false}
    >
      <Modal.Header closeButton className="custom-modal-header">
        <Modal.Title>Configure Quiz</Modal.Title>
      </Modal.Header>
      <Modal.Body className="custom-modal-body">
        <Form>
          <Form.Group className="mb-3">
            <Form.Label className="standard-dropdown-label">
              Quiz Name
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter quiz name"
              value={quizName}
              onChange={(e) => setQuizName(e.target.value)}
            />
          </Form.Group>
          <div style={{ display: "flex", gap: "5px" }}>
            <div  className="standard-dropdown mb-3 w-100">
              <div className="standard-dropdown-label">Quiz Category(s)</div>
              <DropdownButton
                title={
                  quizCategory.length > 0
                    ? quizCategory.join(", ")
                    : "Select Categories"
                }
                onSelect={() => {}}
                className="w-100"
              >
                {categories.length > 0 ? (
                  categories.map((category) => (
                    <Dropdown.Item
                      key={category.id}
                      as="div"
                      onClick={(e) => {
                        e.stopPropagation();
                        setQuizCategory((prev) =>
                          prev.includes(category.text)
                            ? prev.filter((cat) => cat !== category.text)
                            : [...prev, category.text]
                        );
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={quizCategory.includes(category.text)}
                        onChange={() => {}}
                        style={{ marginRight: "10px" }}
                      />
                      {category.text}
                    </Dropdown.Item>
                  ))
                ) : (
                  <Dropdown.Item disabled>
                    No categories available
                  </Dropdown.Item>
                )}
              </DropdownButton>
            </div>
            {quizCategory.length > 0 && numberOfQuestionsArray?.length > 0 && (
              <div className="standard-dropdown mb-3 w-100">
                <div className="standard-dropdown-label">
                  Number of Questions to show
                </div>
                <DropdownButton
                  onSelect={(selectedNumber) =>
                    setNumberOfQuestions(selectedNumber)
                  }
                  title={
                    numberOfQuestions > 0 ? numberOfQuestions : "Select Number"
                  }
                  className="w-100"
                >
                  {numberOfQuestionsArray.map((count) => (
                    <Dropdown.Item key={count} eventKey={count}>
                      {count}
                    </Dropdown.Item>
                  ))}
                </DropdownButton>
              </div>
            )}
          </div>

          <div className="standard-dropdown mb-3">
            <div className="standard-dropdown-label">Question Timer</div>
            <DropdownButton
              title={questionTimer}
              onSelect={(selectedTimer) => setQuestionTimer(selectedTimer)}
              className="w-100"
            >
              {questionTimerOptions.map((option, index) => (
                <Dropdown.Item key={index} eventKey={option}>
                  {option}
                </Dropdown.Item>
              ))}
            </DropdownButton>
          </div>

          <div className="standard-dropdown mb-3">
            <div className="standard-dropdown-label">Question Order</div>
            <DropdownButton
              title={questionOrder}
              onSelect={(selectedOrder) => setQuestionOrder(selectedOrder)}
              className="w-100"
            >
              {questionOrderOptions.map((option, index) => (
                <Dropdown.Item key={index} eventKey={option}>
                  {option}
                </Dropdown.Item>
              ))}
            </DropdownButton>
          </div>

          <div className="standard-dropdown mb-3">
            <div className="standard-dropdown-label">Show Correct Answers</div>
            <DropdownButton
              title={showCorrectAnswers}
              onSelect={(selectedOption) =>
                setShowCorrectAnswers(selectedOption)
              }
              className="w-100"
            >
              {showCorrectAnswersOptions.map((option, index) => (
                <Dropdown.Item key={index} eventKey={option}>
                  {option}
                </Dropdown.Item>
              ))}
            </DropdownButton>
          </div>

          <div className="standard-dropdown mb-3">
            <div className="standard-dropdown-label">Advertising</div>
            <DropdownButton
              title={advertising?.name || "Select Advertising"}
              onSelect={(selectedAd) =>
                setAdvertising(
                  advertisingOptions.find(
                    (option) => option.name === selectedAd
                  )
                )
              }
              className="w-100"
            >
              {advertisingOptions.map((option) => (
                <Dropdown.Item key={option.id} eventKey={option.name}>
                  {option.name}
                </Dropdown.Item>
              ))}
            </DropdownButton>
          </div>

          <div className="button-container d-flex justify-content-between">
            <Button
              variant="outline-primary"
              onClick={onBack}
              className="custom-back-button w-50 me-4"
            >
              Back
            </Button>
            <Button variant="primary" onClick={handleSave} className="w-50">
              Save
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default ConfigureQuizModal;
